module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/ornament-right.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/ornament-right.png
// module id = 485
// module chunks = 0